export const imageSlider = [
  {
    title: "Slide 1",
    urls: "https://icms-image.slatic.net/images/ims-web/d6128e9d-3ee5-44a8-81aa-6d7bc06b05de.jpg",
    color: "#fa5b11",
  },
  {
    title: "Slide 2",
    urls: "https://icms-image.slatic.net/images/ims-web/d15b2f8c-ec96-42a1-9a0e-8facfe8089d4.jpg",
    color: "#3a2e85",
  },
  {
    title: "Slide 3",
    urls: "https://icms-image.slatic.net/images/ims-web/73719cfd-1d03-4add-bdec-23b650e9d637.jpg_1200x1200.jpg",
    color: "#a6f5f1",
  },
  {
    title: "Slide 4",
    urls: "https://icms-image.slatic.net/images/ims-web/d0173bbe-752c-4780-94cd-b0f7ced7de6c.jpg",
    color: "#368064",
  },
  {
    title: "Slide 5",
    urls: "https://icms-image.slatic.net/images/ims-web/a56def53-5064-45b6-aa76-899bd09868a2.jpg",
    color: "#c0faf1",
  },
  {
    title: "Slide 6",
    urls: "https://icms-image.slatic.net/images/ims-web/cae2f0af-ceb4-46e8-a6a9-f8780f125802.jpg",
    color: "#433982",
  },
];